// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nmark,\n.mark {\n  padding: 0 0.2em !important;\n  line-height: 1.5em !important;\n}\n@media (max-width: 768px) {\n.pagination-container div,\n  .pagination-container div p {\n    text-align: center !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
